/* eslint-disable camelcase */
/* eslint-disable no-unused-vars */
import React, { useEffect, useRef, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import style from './style.module.scss'
import UpperSegment from './UpperSegment/Index'
import InteractionArea from './InteractionArea/Index'
import PropTypes from 'prop-types'
import { updateCatalog } from '../../../../Redux/contentUpload/contentUploadSlice'
import { errorToast, successToast } from 'toasts/Toasts'
import DropSample from './DropSample';

function MetaDataForm ({ arrayOfImages, setShowMetaDataForm, selectedType, cancel }) {
  const DEFAULT_CONTENT_STATE = {
    assetType: selectedType,
    contributers: '',
    name: '',
    folder: {},
    isPublic: undefined,
    wordTags: [],
    color: [],
    contentDescription: '',
    format: [],
    size: [],
    filesType: [],
    style: [],
    series: [],
    selectedIndex: 0
  }

  const isUploading = useRef(false)
  const [imgState, setImgState] = useState([])
  const [phaseState, setPhase] = useState(1)
  const [sampleImage, setSampleImage] = useState(null)
  const [atLeastOneSelected, setAtLeastOneSelected] = useState(false)
  const [errors, setErrors] = useState(false)
  const [contentState, setContentState] = useState(DEFAULT_CONTENT_STATE)
  let { folders } = useSelector((state) => state.folders);
  folders = folders?.filter((folder) => folder.parent?.toLowerCase() === selectedType.toLowerCase()) || [];
  const dispatch = useDispatch()

  const user = useSelector((state) => state.auth?.user);
  const [currentUserRole, setCurrentUserRole] = useState({});

  useEffect(() => {
    const role = user?.roles?.length > 0 ? user?.roles[0] : '';
    setCurrentUserRole(role);
  }, [user])

  useEffect(() => {
    const NewArrOfImages = arrayOfImages[0]?.template_data?.templates?.map((el, i) => {
      return {
        id: el.id || i,
        uriData: el.thumbnail,
        active: i === (arrayOfImages[0]?.selectedIndex || 0)
      }
    }) || []
    const contentData = {
      contributers: arrayOfImages[0].contributor || '',
      name: arrayOfImages[0].name || '',
      folder: folders.find(f => f.id === arrayOfImages[0].folders[0]) || {},
      isPublic: arrayOfImages[0].is_public,
      wordTags: arrayOfImages[0].word_tags?.split(',') || [],
      format: arrayOfImages[0].format?.split(',') || [],
      size: arrayOfImages[0].size?.split(',') || [],
      style: arrayOfImages[0].style?.split(',') || [],
      series: arrayOfImages[0].series?.split(',') || [],
      filesType: arrayOfImages[0].files_type?.split(',') || [],
      color: arrayOfImages[0].color?.split(',') || [],
      contentDescription: arrayOfImages[0]?.content_description || '',
      assetType: arrayOfImages[0].assest_type || ''
    };
    setImgState(NewArrOfImages)
    setPhase(2)
    setContentState(contentData || DEFAULT_CONTENT_STATE)
  }, [])

  useEffect(() => {
    if (imgState?.length) {
      const selIdx = imgState.findIndex((el) => el.active)
      const activeOne = imgState[selIdx >= 0 ? selIdx : 0]
      if (activeOne) {
        setAtLeastOneSelected(activeOne)
        setContentState(prev => { return { ...prev, selectedIndex: selIdx >= 0 ? selIdx : 0 } })
      }
    }
  }, [imgState])

  const onChangeData = changes => {
    const filterSelection = { ...contentState }
    let newObj = {}
    const key = changes.category
    if (changes.selected) {
      const newArr = [...filterSelection[key], changes.value]
      newObj = { ...filterSelection, [key]: newArr }
    } else {
      const newArr = filterSelection[key].filter(
        item => item !== changes.value
      )
      newObj = { ...filterSelection, [key]: newArr }
    }
    setContentState(newObj)
  }

  const dataValidity = (data) => {
    const { name, folders, word_tags, contributor, assest_type, is_public } = data
    if (!name || !folders[0] || !contributor || !word_tags.length || !assest_type || is_public === undefined) {
      !assest_type && setErrors(prev => { return { ...prev, sourceType: true } })
      !name && setErrors(prev => { return { ...prev, name: true } })
      !contributor && setErrors(prev => { return { ...prev, contributers: true } })
      !folders[0] && setErrors(prev => { return { ...prev, folder: true } })
      !word_tags.length && setErrors(prev => { return { ...prev, wordTags: true } })
      is_public === undefined && setErrors(prev => { return { ...prev, isPublic: true } })
      return false
    }
    return true
  }

  const submitData = async () => {
    const {
      wordTags,
      name,
      contentDescription,
      contributers,
      format,
      size,
      style,
      series,
      filesType,
      folder,
      isPublic,
      assetType,
      color,
      selectedIndex
    } = { ...contentState }
    try {
      const data = {
        name,
        contributor: contributers,
        assest_type: assetType,
        format: format.join(','),
        size: size.join(','),
        style: style.join(','),
        series: series.join(','),
        files_type: filesType.join(','),
        word_tags: wordTags.join(','),
        content_description: contentDescription,
        folders: [folder.id],
        is_public: isPublic,
        color: color.join(','),
        selectedIndex,
        tempId: arrayOfImages[0].id
      }
      if (dataValidity(data)) {
        if (isUploading.current) {
          errorToast('Please wait until the current upload is finished')
          return;
        }
        try {
          dispatch(updateCatalog(data))
          setShowMetaDataForm(false)
          successToast('Content updated successfully')
        } catch (error) {
          console.log(error)
          errorToast('Something went wrong')
        }
      } else {
        errorToast('Please fill all the required fields')
      }
    } catch (error) {
      console.log(error)
      errorToast('Something went wrong')
    }
  }

  const goNextPhase = () => {
    if (atLeastOneSelected && sampleImage) {
      setPhase(prev => prev + 1)
    }
  }

  return (
    <div className={style.wrapper}>
      <section className={`${style.upperImgsSegment} ${style.inEditMode}`}>
        <UpperSegment
          imgState={imgState}
          setImgState={setImgState}
          selectedN={atLeastOneSelected}
          phaseState={phaseState}
          contentState={contentState}
          setContentState={setContentState}
          editMode={true}
          sampleImage={sampleImage}
          atLeastOneSelected={atLeastOneSelected}
        />
      </section>
      <section className={`${style.interactionArea} ${style.inEditMode}`}>
        {phaseState === 2
          ? (
            <InteractionArea
              contentState={contentState}
              setContentState={setContentState}
              onChangeData={onChangeData}
              phaseState={phaseState}
              folders={folders}
              errors={errors}
              setErrors={setErrors}
              currentUserRole={currentUserRole}
            />
          )
          : (
            <div className={style.noImgSelected}>
              <DropSample setSampleImage={setSampleImage} sampleImage={sampleImage} />
            </div>
          )}
      </section>
      <section className={style.uploadSection}>
        <div className={style.uploadBtn}>
          <button
            type='submit'
            className={
              atLeastOneSelected
                ? `${style.submitBtn}`
                : `${style.submitBtn} ${style.inactive}`
            }
            onClick={() => phaseState === 1 ? goNextPhase() : submitData()}
          >
            {phaseState === 1 ? 'Next' : 'Finish'}
          </button>
        </div>
        <div className={style.uploadBackAndSkip}>
          <button
            type='button'
            onClick={() => cancel ? cancel() : setShowMetaDataForm(false)}
            className={`${style.cancel}`}
          // disabled={uploading}
          >
            Cancel
          </button>
        </div>
      </section>
    </div>
  )
}

MetaDataForm.propTypes = {
  arrayOfImages: PropTypes.array,
  setShowMetaDataForm: PropTypes.func,
  uploadContent: PropTypes.func,
  selectedType: PropTypes.string,
  editMode: PropTypes.bool,
  cancel: PropTypes.func,
  backFn: PropTypes.func
}

export default MetaDataForm
